// extracted by mini-css-extract-plugin
module.exports = {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","button":"g_2sO","flexContainer":"_3WUkw","count":"_3HivP"};